import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  getActionTypeDirections,
} from 'cityads-v3/actions/offers';

@connect(
  (state, props) => ({
    actionTypeDirection: state.offers.action_type_directionById[props.id] || {},
    language: state.language.language,
  })
)
export default class ActionTypeDirection extends Component {

  static propTypes = {
    id: PropTypes.number.isRequired,
    actionTypeDirection: PropTypes.object,
    language: PropTypes.string,
  }

  componentDidMount() {
    const { dispatch, actionTypeDirection } = this.props;

    if (typeof actionTypeDirection.name === 'undefined') {
      dispatch(getActionTypeDirections());
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const oldProps = this.props;
    const { dispatch, language, actionTypeDirection } = newProps;

    if (
      (typeof oldProps.actionTypeDirection.name !== 'undefined' && typeof actionTypeDirection.name === 'undefined') ||
      oldProps.language !== language
    ) {
      dispatch(getActionTypeDirections());
    }
  }

  render() {
    const { actionTypeDirection } = this.props;
    return <>{actionTypeDirection.name}</>
  }
}
